let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("jNAgs")).then(() => parcelRequire('gAvT5'));